export default __webpack_public_path__ + "static/media/la_ferte-vidame12.0401bf43.jpg";